import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=e7fc3a0a&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7fc3a0a')) {
      api.createRecord('e7fc3a0a', component.options)
    } else {
      api.reload('e7fc3a0a', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=e7fc3a0a&", function () {
      api.rerender('e7fc3a0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O3w47xxe97Od/JS/pricehelp.vue"
export default component.exports